import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  all: (siteId?: string) =>
    fetchPages<SocieteResponse>('societes', `${config.ws.societe.all}${siteId ? `?siteId=${siteId}` : ''}`, 'GET'),
  get: (siteId: string, id: string) =>
    ws<SocieteResponse>(config.ws.societe.get.replace('{id}', id) + `?siteId=${siteId}`, 'GET'),
}

export default api
